export const DEFAULT_CONNECT_TIMEOUT = 10_000;
/**
 * 1リクエスト全体の上限（約8.5分）。sendAndStream の固定タイマーであり、
 * progress/token 受信では reset されない。
 *
 * サーバー側と意図的にずらした3層構成の中間値（内側から）:
 *   AgentCore read 480s < この 510s < WsMessage Lambda 540s
 * AgentCore が先に timeout し、Lambda がそれを捕捉して error frame を push できる。
 * このクライアント側 fallback はその error frame が届かない場合のみ発火する。
 */
export const DEFAULT_MESSAGE_TIMEOUT = 510_000;
export const DEFAULT_UNAUTHORIZED_REDIRECT_URL = '/unauthorized';
